import React, { createContext, useContext, useState, useCallback } from 'react';
import { HeaderProps } from '../components/Header';

interface LayoutContextType {
  headerProps: HeaderProps;
  updateHeaderProps: (props: Partial<HeaderProps>) => void;
}

const defaultHeaderProps: HeaderProps = {
  pageTitle: '',
  userName: '',
  userEmail: '',
  userAvatar: '',
  showPageTitle: true,
  showUserInfo: false,
  showUserAvatar: false,
  showClientLogo: true
};

const LayoutContext = createContext<LayoutContextType>({
  headerProps: defaultHeaderProps,
  updateHeaderProps: () => {}
});

export const LayoutProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [headerProps, setHeaderProps] = useState<HeaderProps>(defaultHeaderProps);

  // Memoize updateHeaderProps to prevent infinite loops in components that depend on it
  const updateHeaderProps = useCallback((props: Partial<HeaderProps>) => {
    setHeaderProps(prevProps => ({ ...prevProps, ...props }));
  }, []);

  return (
    <LayoutContext.Provider value={{ headerProps, updateHeaderProps }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => useContext(LayoutContext); 